import React, { useEffect, useState } from 'react';

import { SelectedFileViewComponent } from '@features/task/components/TaskManageComponents/SelectedFileViewComponent';

import { convertDateToLocal, parseAndRenderLinks } from '@utils/Util';

const PostReplyList = ({ commentList, highlightReplyId }) => {
	const [viewAllReply, setViewAllReply] = useState(false);

	useEffect(() => {
		if (highlightReplyId) {
			setViewAllReply(true);
		}
	}, []);

	const renderFilePreview = (fileList) => {
		if (fileList.length > 0) {
			return (
				<div className={'files-n-photos custom-scrollbar}'}>
					{fileList.map((file, i) => {
						return (
							<SelectedFileViewComponent
								showRemoveOption={false}
								file={file}
								key={i}
								index={i}
								remove={() => false}
							/>
						);
					})}
				</div>
			);
		}
	};

	const renderCommentList = () => {
		let postCommentList = [];
		if (commentList.length > 1 && !viewAllReply) {
			postCommentList.push(commentList[0]);
		} else {
			postCommentList = [...commentList];
		}
		return postCommentList.map((comment, index) => {
			return (
				<div
					className={`single-reply ${comment.id === highlightReplyId ? 'highlight-wrapper' : ''}`}
					key={`replay_${index}`}
				>
					<div className="title">
						<img
							src={
								comment?.postedBy?.imageUrl
									? comment?.postedBy?.imageUrl
									: `${process.env.PUBLIC_URL}/images/pro_pic_default.svg`
							}
							alt="profile"
							className="profile-image"
						/>

						<span className="regular-14 gray_dark_01 weight-500">{comment?.postedBy?.name}</span>
						{comment?.artBoardName && (
							<span className="semibold-12 gray_dark_02 ml-1">
								{' '}
								on <span className="text-uppercase">{comment?.artBoardName}</span>
							</span>
						)}
						<p className="regular-12 gray_dark_02">
							{convertDateToLocal(comment.dateAdded, 'hh:mm A DD MMM, YYYY')}
						</p>
					</div>
					<div className="comments-description child">
						<p
							dangerouslySetInnerHTML={{
								__html: parseAndRenderLinks(comment?.text)
							}}
							className="description-text"
							style={{ wordWrap: 'break-word' }}
						/>
						{renderFilePreview(comment.docList, false)}
					</div>
				</div>
			);
		});
	};

	return (
		<>
			{renderCommentList()}
			{commentList.length > 1 && !viewAllReply && (
				<button onClick={() => setViewAllReply(true)} className="button text reply">
					View {commentList.length} replies
				</button>
			)}
		</>
	);
};

export default PostReplyList;
